import { Suspense, useEffect } from "react";
import { useState } from "react";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";

import {
  MantineProvider, Box,
  Text,
  defaultVariantColorsResolver,
  parseThemeColor, localStorageColorSchemeManager
} from "@mantine/core";
//  import modules from 'modules';
import "./App.scss";
import { connect, useDispatch } from "react-redux";
import Shell from "./shell/Shell";
//  import ErrorBoundary from 'components/errorBoundary/errorBoundary';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthModule } from "../modules/index";
// import ApprovalModule from 'modules/Approval/ApprovalModule';
import { logoutUser, setUser } from "modules/Auth/authSlice";
import { getProp } from "utils/helper";
import { logger } from "utils/logger";
import { openConfirmModal } from "@mantine/modals";
import { fetchAggData, fetchDepartments, setPreviousRoute } from "./appSlice";
import ErrorBoundary from "core/components/errorBoundary/errorBoundary";
import { MantineEmotionProvider } from "@mantine/emotion";
import { Notifications } from "@mantine/notifications";
import classes from './App.module.scss'; // include this for global module styles

var loadingTimer = null;
var psudoLoad = 60;

const App = ({ user, setUser, isLoading, setPreviousRoute }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!user) {
      const userStr = getProp("user");
      if (userStr) {
        const tmpUser = JSON.parse(userStr);
        setUser(tmpUser);
      }
    } else {
      dispatch(fetchAggData());
      dispatch(fetchDepartments());
    }
  }, [user, dispatch, setUser]);

  const signOut = () => {
    // set the previous route so we can redirect them after they login in again we pass it as
    // a param as the logout function refreshes the state.
    var redirect = `${window.location.pathname}`;
    if (window.location.search && window.location.search.length) {
      redirect += `${window.location.search}`;
    }

    dispatch(logoutUser(user, redirect));
  };

  /**
   * Need a better place to put this for auth checking right now we'll place it here
   */
  useEffect(() => {
    const { fetch: originalFetch } = window;
    window.fetch = async (...args) => {
      let [resource, config] = args;

      let response = await originalFetch(resource, config);

      if (
        !response.ok &&
        (response.status === 401 || response.status === 404)
      ) {
        logger.log(response)

        if(response.statusText && response.statusText === "Not Found"){
          return;
        }

        // 404 error handling
        let path = window.location.pathname.toLowerCase();
        path = path.split("/");

        if (path[1] !== "auth" && !modalOpen) {
          // we need to show a modal to let them know whe're loggin them out.
          const openModal = () =>
            openConfirmModal({
              title: "Session Expired",
              children: (
                <Text size="sm">
                  Your session has expired, you'll need to log back in to
                  continute using OnSet.
                </Text>
              ),
              labels: { confirm: "Login", cancel: "Cancel" },
              onCancel: () => {
                setModalOpen(false);
              },
              onConfirm: () => signOut(),
            });

          openModal();
          setModalOpen(true);
        }

        return Promise.reject(response);
      }
      return response;
    };
  }, []);

  useEffect(() => {
    const cancelLoading = () => {
      clearInterval(loadingTimer);
      loadingTimer = null;
    };
    if (isLoading && !loadingTimer) {
      loadingTimer = setInterval(() => {
        const progress = psudoLoad + (100 - psudoLoad) / 2;
        logger.log(progress, " ======= LOAD PROGRES");
        psudoLoad = progress;

        if (progress >= 90) {
          cancelLoading();
        }
        setLoadProgress(psudoLoad);
      }, 5);
    }
    if (!isLoading && loadingTimer) {
      cancelLoading();
    }
    if (!isLoading) {
      psudoLoad = 60;
      setLoadProgress(100);
      setTimeout(() => {
        setLoadProgress(0);
        cancelLoading();
      }, 1500);
    }
  }, [isLoading]);

  const [loadProgress, setLoadProgress] = useState(20);

  // const navigate = useNavigate();
  // const [colorScheme, setColorScheme] = useLocalStorage({
  //   key: "onset-public-color-scheme",
  //   defaultValue: "dark",
  //   getInitialValueInEffect: true,
  // });

  const colorSchemeManager = localStorageColorSchemeManager({
    key: "onset-public-color-scheme",
  });

  const colorScheme = colorSchemeManager.get() || 'dark';

  const variantColorResolver = (input) => {
    const tmpScheme = colorSchemeManager.get() || 'dark';
    const defaultResolvedColors = defaultVariantColorsResolver(input);
    const parsedColor = parseThemeColor({
      color: input.color || input.theme.primaryColor,
      theme: input.theme,
    });

    // Override some properties for variant
    if (
      parsedColor.isThemeColor &&
      parsedColor.color === "brand" &&
      input.variant === "filled"
    ) {
      // logger.log(parsedColor, input, scheme, colorScheme)

      const variant = {
        ...defaultResolvedColors,
        color:
        tmpScheme === "dark"
            ? "var(--mantine-color-brand-9)"
            : "var(--mantine-color-white)",
        hoverColor: "var(--mantine-color-white)",
        background:
        tmpScheme === "dark"
            ? "var(--mantine-color-brand-filled)"
            : "var(--mantine-color-brand-6)",

        hover: "var(--mantine-color-brand-6)",
      };

      return variant;
    }

    if (
      parsedColor.isThemeColor &&
      parsedColor.color === "brand" &&
      input.variant === "subtle"
    ) {
      return {
        ...defaultResolvedColors,
        color: "var(--mantine-color-brand-5)",
        // hoverColor: 'var(--mantine-color-white)',
        // hover: 'var(--mantine-color-brand-6)',
      };
    }

    if (
      parsedColor.isThemeColor &&
      parsedColor.color === "brand" &&
      input.variant === "light"
    ) {
      
      return {
        ...defaultResolvedColors,
        // color: "var(--mantine-color-brand-5)",
        color:
        tmpScheme === "dark"
            ? "var(--mantine-color-brand-5)"
            : "var(--mantine-color-brand-6)",
        // hoverColor: 'var(--mantine-color-white)',
        // hover: 'var(--mantine-color-brand-6)',
      };
    }

    if (
      parsedColor.isThemeColor &&
      parsedColor.color === "brand" &&
      input.variant === "light"
    ) {
      return {
        ...defaultResolvedColors,
        // color: "var(--mantine-color-brand-5)",
        color:
        tmpScheme === "dark"
            ? "var(--mantine-color-brand-5)"
            : "var(--mantine-color-black)",
        color: "red",
        // hoverColor: 'var(--mantine-color-white)',
        // hover: 'var(--mantine-color-brand-6)',
      };
    }

    return defaultResolvedColors;
  };

  return (
    <MantineProvider
      withGlobalStyles
      withNormalizeCSS
      colorSchemeManager={colorSchemeManager}
      styles={{
        Title: (theme) => ({
          root: {
            color:
              theme.colorScheme === "dark"
                ? theme.colors.gray[0]
                : theme.colors.gray[9],
          },
        }),
        Text: (theme) => ({
          root: {
            color: theme.colorScheme === "dark" ? theme.colors.gray[3] : "",
          },
          dimmed: {
            color: "red",
          },
        }),
      }}
      defaultColorScheme={"dark"}
      theme={{
        variantColorResolver,
        colorScheme: colorScheme,
        // background: 'red',
        // fontFamily: 'Verdana, sans-serif',
        defaultRadius: "md",
        fontFamilyMonospace: "Monaco, Courier, monospace",
        headings: { fontFamily: "Poppins, sans-serif" },
        // primaryShade: 4,
        globalStyles: (theme) => ({
          ".body-panels": {
            backgroundColor:
              theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.white,
          },
          ".scrollTableHeader": {
            position: "sticky",
            top: 0,
            backgroundColor:
              theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.white,
            transition: "box-shadow 150ms ease",
            zIndex: 2,
            "&::after": {
              content: '""',
              position: "absolute",
              left: 0,
              right: 0,
              bottom: 0,
              borderBottom: `1px solid ${
                theme.colorScheme === "dark"
                  ? theme.colors.dark[3]
                  : theme.colors.gray[2]
              }`,
            },
          },
          ".tableHeader-scrolled": {
            boxShadow: theme.shadows.sm,
          },

          ".displayFooter": {
            // position:'fixed',
            bottom: 0,
            background:
              theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.white,
            // right:theme.spacing.lg,
            padding: theme.spacing.sm,
            paddingLeft: theme.spacing.lg,
            // right:0,
            // left:221,
            borderTop: "1px solid",
            borderColor:
              theme.colorScheme === "dark"
                ? theme.colors.dark[5]
                : theme.colors.gray[3],
          },
          ".cellChecked": {
            background:
              theme.colorScheme === "dark"
                ? `${theme.colors.dark[6]} !important`
                : `${theme.white} !important`,
          },
          ".list-stack": {
            gap: 0,
            ".list-renderer-item": {
              paddingBottom: theme.spacing.md,
              paddingLeft: theme.spacing.md,
              paddingRight: theme.spacing.md,
              "&:hover": {
                background:
                  theme.colorScheme === "dark"
                    ? `${theme.colors.dark[6]} !important`
                    : `${theme.white} !important`,
              },
            },
          },
          ".list-renderer-item": {
            borderTop: "1px solid",
            borderColor:
              theme.colorScheme === "dark"
                ? theme.colors.dark[5]
                : theme.colors.gray[3],
          },
          ".menuItem": {
            display: "block",
            width: "100%",
            padding: theme.spacing.xs,
            borderRadius: theme.radius.sm,
            color:
              theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,

            "&:hover": {
              backgroundColor:
                // theme.colorScheme === 'dark' ? theme.colorScheme : theme.colors.gray[0],
                theme.colorScheme === "dark"
                  ? theme.colorScheme
                  : theme.colorScheme,
              ".themeIcon": {
                color: theme.colors.brand[1],
                backgroundColor: theme.colors.brand[4],

                svg: {
                  transform: "scale(1.1)",
                },
              },
            },
            "&.active": {
              color: theme.white,
              ".themeIcon": {
                color: theme.colors.brand[1],
                backgroundColor: theme.colors.brand[6],
              },
            },
          },
          ".panelHeading": {
            borderBottom: `1px solid ${theme.colors.gray[2]}`,
            borderColor:
              theme.colorScheme === "dark"
                ? theme.colors.dark[5]
                : theme.colors.gray[2],
          },
          ".h-scroll-table": {
            "thead th": {
              backgroundColor:
                theme.colorScheme === "dark"
                  ? `${theme.colors.dark[8]}`
                  : `${theme.white}`,
            },
            "thead th:nth-child(2),tbody td:nth-child(2)": {
              borderRight:
                theme.colorScheme === "dark"
                  ? `1px solid ${theme.black}`
                  : `1px solid ${theme.colors.gray[3]}`,
              backgroundColor:
                theme.colorScheme === "dark"
                  ? `${theme.colors.dark[8]}`
                  : `${theme.white}`,
            },
            "tr:hover": {
              "td:nth-child(2)": {
                backgroundColor:
                  theme.colorScheme === "dark"
                    ? `${theme.colors.dark[5]}`
                    : `${theme.colors.gray[1]}`,
              },
            },
          },
          ".h-scroll-table-first-column": {
            "thead th": {
              backgroundColor:
                theme.colorScheme === "dark"
                  ? `${theme.colors.dark[8]}`
                  : `${theme.white}`,
            },
            "thead th:nth-child(1),tbody td:nth-child(1)": {
              borderRight:
                theme.colorScheme === "dark"
                  ? `1px solid ${theme.black}`
                  : `1px solid ${theme.colors.gray[3]}`,
              backgroundColor:
                theme.colorScheme === "dark"
                  ? `${theme.colors.dark[8]}`
                  : `${theme.white}`,
            },
            "tr:hover": {
              "td:nth-child(1)": {
                backgroundColor:
                  theme.colorScheme === "dark"
                    ? `${theme.colors.dark[5]}`
                    : `${theme.colors.gray[1]}`,
              },
            },
          },
        }),
        colors: {
          brand: [
            "#FAFCF6",
            "#F0F4E6",
            "#d0dfe0",
            "#7e9b9d",
            "#7EAEA9",
            "#BBD1C6",
            "#577470",
            "#36494a",
            "#7EAEA9",
            "#2B3A3B",
          ],
        },
        // fontSizes:{xs:'12px',sm:'12px'},
        primaryColor: "brand",
        defaultGradient: {
          from: "#ff6b6b",
          to: "#4ecdc4",
          deg: 45,
        },
        components: {
          Button: {
            // Set default variant to filled
            defaultProps: {
              variant: "filled",
            },
            // styles: {
            //   root: {
            //     '&[data-color="brand"]': {
            //       background: 'linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1, #ff6b6b)',
            //       '&:not([data-disabled]):hover': {
            //         background: 'linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1, #ff6b6b)',
            //         opacity: 0.9,
            //       }
            //     }
            //   }
            // }
          },
          Mark: {
            styles: (theme) => ({
              root: {
                backgroundColor:
                  theme.colorScheme === "dark"
                    ? theme.colors.brand[4]
                    : theme.colors.yellow[4],
                  fontWeight: 600,
                // color:
                //   theme.colorScheme === "dark"
                //     ? theme.colors.white
                //     : 'white',
              },
            }),
          },
          // Button: {
          //     // Set default variant to filled
          //     defaultProps: {
          //       variant: 'filled',
          //     },
          //     styles: {
          //       root: {
          //         '&[data-color="brand"]': {
          //           background: 'linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1, #ff6b6b)',
          //           '&:not([data-disabled]):hover': {
          //             background: 'linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1, #ff6b6b)',
          //             opacity: 0.9,
          //           }
          //         }
          //       }
          //     }
          // }
          // Button: {
          //   defaultProps: {
          //     size: 'xs'  // 'xs', 'sm', 'md', 'lg', 'xl'
          //   }
          // },
          // Input: {
          //   defaultProps: {
          //     size: 'xs'
          //   }
          // },
          // Select: {
          //   defaultProps: {
          //     size: 'xs'
          //   }
          // },
        },
      }}
    >
      <Notifications />
      <MantineEmotionProvider>
        {/* <NotificationsProvider> */}

        <BrowserRouter>
          {/* <AltitudeSpotlight> */}
          <div>
            {/* progress loader */}
            {loadProgress ? (
              <Box
                className="progress-bar"
                sx={(theme) => ({
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 3,
                  backgroundColor: theme.colors.dark,
                  zIndex: 101,
                })}
              >
                <Box
                  className="progress-inner"
                  sx={(theme) => ({
                    position: "absolute",
                    top: 0,
                    left: 0,
                    minWidth: `${loadProgress}%`,
                    height: 3,
                    background: theme.fn.linearGradient(
                      45,
                      "#BBD1C6",
                      "#FDABA4"
                    ),
                  })}
                ></Box>
              </Box>
            ) : null}
            <ErrorBoundary user={user}>
              <Routes>
                <Route
                  path="/*"
                  element={<Shell theme={colorScheme} user={user} />}
                />
                {/* <Route
                  path="/approval/*"
                  element={
                    // <ErrorBoundary>
                    <Suspense fallback={<div></div>}>
                      <ApprovalModule theme={colorScheme} /> 
                    </Suspense>
                    // </ErrorBoundary>
                  }
                /> */}
                <Route path="/auth/*" element={<AuthModule />} />
              </Routes>
            </ErrorBoundary>
          </div>
          {/* </AltitudeSpotlight> */}
        </BrowserRouter>
      </MantineEmotionProvider>
      {/* </NotificationsProvider> */}
    </MantineProvider>
    // </ColorSchemeProvider>
  );
};


const mapStateToProps = (state) => ({
  user: state.auth.user,
  isLoading: state.appReducer.loading,
});

const mapDispatchToProps = { setUser, setPreviousRoute };

export default connect(mapStateToProps, mapDispatchToProps)(App);
